export enum PaymentMethod {
  Pix = 0,
  BankingBillet = 1,
  CreditCard = 3,
  Cash = 5,
};
